<template>
  <div>
    <p
    class="process-repair-tab-section-title mt-5"
    style="font-size: 20px; position: relative; top: 20px;">
      {{$t('pages.repair.contactDetails')}}
    </p>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-first-name
        v-model="firstNameProp"
        required
        :readonly="readonly"
        :disabled="disabled"
        :label="$t('textFields.firstName')"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-last-name
        v-model="lastNameProp"
        required
        :readonly="readonly"
        :disabled="disabled"
        :label="$t('textFields.lastName')"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-phone
        v-model="phoneProp"
        required
        :readonly="readonly"
        :disabled="disabled"
        :label="$t('textFields.phone')"/>
      </v-col>
    </v-row>
    <v-row
    class="mt-2"
    dense
    no-gutters>
      <v-col>
        <text-field-email
        v-model="emailProp"
        required
        :readonly="readonly"
        :disabled="disabled"
        :label="$t('textFields.email')"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextFieldFirstName from '@/components/text-fields/TextFieldFirstName'
import TextFieldLastName from '@/components/text-fields/TextFieldLastName'
import TextFieldPhone from '@/components/text-fields/TextFieldPhone'
import TextFieldEmail from '@/components/text-fields/TextFieldEmail'
export default {
  components: {
    TextFieldFirstName,
    TextFieldLastName,
    TextFieldPhone,
    TextFieldEmail
  },
  props: {
    firstName: String,
    lastName: String,
    phone: String,
    email: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    firstNameProp: {
      get: function() {
        return this.$props.firstName
      },
      set: function(v) {
        this.$emit("update:firstName", v)
      }
    },
    lastNameProp: {
      get: function() {
        return this.$props.lastName
      },
      set: function(v) {
        this.$emit("update:lastName", v)
      }
    },
    phoneProp: {
      get: function() {
        return this.$props.phone
      },
      set: function(v) {
        this.$emit("update:phone", v)
      }
    },
    emailProp: {
      get: function() {
        return this.$props.email
      },
      set: function(v) {
        this.$emit("update:email", v)
      }
    }
  }
}
</script>

<style>

</style>